<template>
  <ProductContentDetails
    :offer="offer"
    class="delivered-items"
    headline="Lieferumfang"
    :render-item-if="(prod) => prod.deliveredItems?.length > 0"
  >
    <template #default="props">
      <BulletPointList :list="props.product?.deliveredItems" />
    </template>
  </ProductContentDetails>
</template>

<script setup lang="ts">
import BulletPointList from '~/components/bullet-point-list.vue';
import ProductContentDetails from '~/components/product-detail/tabs/product-content-details.vue';

export type DeliveredItemsProps = {
  offer?: Offer | undefined;
};

withDefaults(defineProps<DeliveredItemsProps>(), {
  offer: undefined,
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
</style>
